import React from "react";

const About = () => {
  return (
    <div className="about-container">
      <h1 className="about-title">About Us</h1>
      <p className="about-description">
        Welcome to <strong>Good People</strong>, a platform designed to bring people closer,  
        encourage open conversations, and offer a space where everyone feels heard and supported.
      </p>

      <h2 className="about-subtitle">Our Mission</h2>
      <p className="about-description">
        At **Good People**, we believe that meaningful connections can transform lives.  
        Whether you're looking for guidance, seeking emotional support, or simply  
        want to share your experiences, our platform is here to help.
      </p>

      <h2 className="about-subtitle">What We Offer</h2>
      <ul className="about-list">
        <li><strong>Psychologist Support:</strong> Connect with professional psychologists for guidance and support.</li>
        <li><strong>Voice & Video Calls:</strong> Engage in one-on-one conversations with experts and mentors.</li>
        <li><strong>Community & Friendships:</strong> Meet like-minded individuals and build meaningful relationships.</li>
        <li><strong>Home Visit Services:</strong> For those needing in-person counseling, we provide home visit options.</li>
        <li><strong>Secure & Private:</strong> Your conversations remain safe, confidential, and free from judgment.</li>
      </ul>

      <h2 className="about-subtitle">Why Choose Good People?</h2>
      <p className="about-description">
        In today's fast-paced world, loneliness and stress have become common challenges.  
        We aim to break these barriers by creating a **safe, welcoming, and non-judgmental space**  
        where you can talk, listen, and feel supported.
      </p>

      <p className="about-description">
        **Join Good People today** and be part of a community that cares.  
        Start meaningful conversations, make connections, and find support when you need it the most.
      </p>
    </div>
  );
};

export default About;
